/**
 * API Response Helper
 * Provides utilities to extract data and messages from standardized API responses
 */

export interface ApiResponse<T = any> {
  success: boolean;
  statusCode: number;
  message: string;
  data: T | null;
  errors?: any;
}

/**
 * Extract data from API response
 * Handles both standardized and legacy response formats
 */
export function extractData<T = any>(response: any): T {
  // If response is already in standardized format
  if (response && typeof response === 'object' && 'data' in response) {
    return response.data as T;
  }
  // Legacy format - return response as-is
  return response as T;
}

/**
 * Extract message from API response
 */
export function extractMessage(response: any): string {
  if (response && typeof response === 'object' && 'message' in response) {
    return response.message;
  }
  return 'Success';
}

/**
 * Check if response is successful
 */
export function isSuccess(response: any): boolean {
  if (response && typeof response === 'object' && 'success' in response) {
    return response.success === true;
  }
  // Legacy format - assume success if no error
  return true;
}

/**
 * Extract error message from error response
 */
export function extractErrorMessage(error: any): string {
  if (error && typeof error === 'object') {
    if (error.message) {
      return error.message;
    }
    if (error.error && error.error.message) {
      return error.error.message;
    }
  }
  return 'An error occurred';
}





